import { useEffect } from 'react';
import { RUTAS_CLIENTE } from '../rutas';

/**
 * G922 (ADR-0234): reservar, pedir cita y comprar entradas dentro del marco de un widget (`marco=widget`) mandan
 * `reservaria:resize` (`height`) a `widget.js` cada vez que cambia su altura, como pide el contrato del widget: el marco
 * ajusta su alto sin dejarlo fijo. Solo la altura (ningún dato personal); `widget.js` comprueba el origen del marco.
 */
const ENMARCABLES = [RUTAS_CLIENTE.reservar, RUTAS_CLIENTE.pedirCita, RUTAS_CLIENTE.comprarEntradas] as const;

export function esPaginaEnMarco(ruta: string, busqueda: URLSearchParams | undefined): boolean {
    return busqueda?.get('marco') === 'widget' && ENMARCABLES.some((r) => ruta === r || ruta.startsWith(`${r}/`));
}

/** Avisa de la altura al marco mientras `activo`; `ventana` es para las pruebas. */
export function useAlturaEnMarco(activo: boolean, ventana: Window = window): void {
    useEffect(() => {
        if (!activo || ventana.parent === ventana) {
            return;
        }
        const raiz = ventana.document.documentElement;
        let ultima = -1;
        const avisar = () => {
            const alto = Math.ceil(raiz.scrollHeight);
            if (alto !== ultima) {
                ultima = alto;
                ventana.parent.postMessage({ type: 'reservaria:resize', height: alto }, '*');
            }
        };
        avisar();
        if (typeof ResizeObserver === 'undefined') {
            return;
        }
        const observador = new ResizeObserver(avisar);
        observador.observe(raiz);
        observador.observe(ventana.document.body);
        return () => {
            observador.disconnect();
        };
    }, [activo, ventana]);
}
